<!-- ── TOP NAVIGATION BAR ── -->
<nav class="adv-navbar fixed-header noprint">
  <!-- Logo -->
  <a routerLink="/" class="adv-navbar-logo">
    <img src="assets/adventum-logo.svg" alt="Adventum Calculators" class="adv-navbar-logo__img">
  </a>

  <!-- Desktop links -->
  <div class="adv-navbar-links">
    <a class="adv-nav-link" (click)="About()" style="cursor:pointer;">About</a>
    <a class="adv-nav-link" href="https://www.adventumwealth.com/#return-to-top" target="_blank">Contact</a>

    <ng-container *ngIf="!validation.checkSession()">
      <a class="adv-nav-link" (click)="changepage(1)" style="cursor:pointer;">Login</a>
      <button class="adv-nav-btn" (click)="changepage(2)">Register</button>
    </ng-container>

    <ng-container *ngIf="validation.checkSession()">
      <a class="adv-nav-link" (click)="Logout()" style="cursor:pointer;">Logout</a>
    </ng-container>
  </div>

  <!-- Mobile hamburger -->
  <button
    class="adv-hamburger"
    [class.hidden-xs]="router.url === '/login'"
    data-toggle="modal"
    data-target="#navbar-modal"
    type="button">
    <span></span>
    <span></span>
    <span></span>
  </button>
</nav>

<!-- ── MOBILE MENU MODAL ── -->
<div id="navbar-modal" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <!-- Logo inside modal -->
        <div class="adv-modal-logo">
          <img src="assets/adventum-logo.svg" alt="Adventum Calculators" class="adv-modal-logo__img">
        </div>

        <ul class="navmobile-link">
          <li class="main-nav"><a routerLink="/" data-dismiss="modal">Calculators</a></li>
          <li class="sub-nav"><a routerLink="/step1" data-dismiss="modal">Investment Property Calculator</a></li>
          <li class="sub-nav"><a routerLink="/cashflow/step1" data-dismiss="modal">Cashflow Calculator</a></li>
          <li class="sub-nav"><a routerLink="/capital-growth-calculator/question" data-dismiss="modal">Capital Growth Calculator</a></li>
          <li class="sub-nav"><a routerLink="/estimated-weekly-rent-calculator/question" data-dismiss="modal">Estimated Weekly Rent Calculator</a></li>
          <li class="sub-nav"><a routerLink="/Predictive-Foreign-calculator/question" data-dismiss="modal">Predictive Foreign Exchange</a></li>
          <li class="sub-nav"><a routerLink="/stamp-duty-calculator/question" data-dismiss="modal">Stamp Duty Calculator</a></li>
          <li class="sub-nav"><a routerLink="/ated/step1" data-dismiss="modal">ATED Calculator</a></li>
          <li class="main-nav"><a (click)="About()" data-dismiss="modal">About</a></li>
          <li class="main-nav"><a (click)="changepage(1)" data-dismiss="modal">Login</a></li>
          <li class="main-nav"><a (click)="changepage(2)" data-dismiss="modal">Register</a></li>
          <li class="main-nav"><a href="https://www.adventumwealth.com/#return-to-top" target="_blank">Contact</a></li>
        </ul>

        <div class="social-links">
          <a href="https://twitter.com/login" target="_blank"><i class="fa fa-twitter"></i></a>
          <a href="https://www.facebook.com/" target="_blank"><i class="fa fa-facebook"></i></a>
          <a href="https://www.google.com/" target="_blank"><i class="fa fa-google"></i></a>
          <a href="https://www.instagram.com/accounts/login" target="_blank"><i class="fa fa-instagram"></i></a>
        </div>

        <div class="privacy-link">
          <ul>
            <li><a href="#">Privacy Policy</a></li>
            <li><a href="#">Terms &amp; Conditions</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
